import { render, staticRenderFns } from "./CoursewareDashboardStudents.vue?vue&type=template&id=35718f1e&scoped=true&"
import script from "./CoursewareDashboardStudents.vue?vue&type=script&lang=js&"
export * from "./CoursewareDashboardStudents.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareDashboardStudents.vue?vue&type=style&index=0&id=35718f1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35718f1e",
  null
  
)

export default component.exports